import React from "react";
import { RiHomeHeartLine, RiSecurePaymentLine } from "react-icons/ri";
import { FaShippingFast } from "react-icons/fa";
import { BsChatSquareText } from "react-icons/bs";
import styles from "./IconContainer.module.css";

function IconContainer() {
  return (
    <div className={styles.iconContainer + " container"}>
      <div className="row justify-content-center px-4">
        <div className={styles.column1 + " col-lg-3 col-6 text-center"}>
          <RiHomeHeartLine className={styles.icons} />
          <p className={styles.text + " text-muted"}>Con amor, hecho en casa</p>
        </div>
        <div className={styles.column2 + " col-lg-3 col-6 text-center"}>
          <FaShippingFast className={styles.icons} />
          <p className={styles.text + " text-muted"}>Envíos a todo el país</p>
        </div>
        <div className={styles.column3 + " col-lg-3 col-6 text-center"}>
          <RiSecurePaymentLine className={styles.icons} />
          <p className={styles.text + " text-muted"}>Medios de pago seguros</p>
        </div>
        <div className={styles.column4 + " col-lg-3 col-6 text-center"}>
          <BsChatSquareText className={styles.icons} />
          <p className={styles.text + " text-muted"}>
            ¡Hacé tu pedido anticipado!
          </p>
        </div>
      </div>
    </div>
  );
}

export default IconContainer;
